import { getLocale } from "@/common/utils/localeUtils";

const formatters: Record<string, Intl.NumberFormat> = {};

export function currencyFormatter(currency?: string): Intl.NumberFormat {
  currency = currency || "USD";
  let ret = formatters[currency];
  if (ret === undefined) {
    const locale = getLocale();
    ret = new Intl.NumberFormat(locale, {
      style: "currency",
      currency: currency,
    });
    formatters[currency] = ret;
  }
  return ret;
}

export function formatCurrency(
  currency: string | undefined,
  value: number,
): string {
  return currencyFormatter(currency).format(value);
}
